import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import AppAppBar from '../components/AppAppBar';

const APP_BAR_HEIGHT = 64;

/**
 * Root layout — renders once, stays mounted during navigation.
 * AppAppBar never re-renders on child state changes.
 * Each page manages its own scroll via PageLayout.
 */
export default function AppLayout() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#0d0d1a' }}>
            <AppAppBar />
            <Box sx={{ height: APP_BAR_HEIGHT, flexShrink: 0 }} />
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <Outlet />
            </Box>
        </Box>
    );
}
